import * as React from 'react';
import { Dispatch } from 'redux';
import { EventsStatsMap } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import { NormalizedEventStatistics, normalizeEventStatistics } from '../normalizers/eventStatisticsNormalizers';

export class GetIndividualEventsStatisticsRequest extends BaseApiPostRequest<
  EventsStatsMap,
  EntityNormalizers.NormalizedEntityArray<NormalizedEventStatistics>
> {
  constructor(eventIds: string[], component: React.Component, dispatch: Dispatch) {
    super({ eventIds }, component, dispatch);
    this.path = `/event-statistics`;
    this.normalizeMethod = normalizeEventStatistics;
  }
}
